var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9167 6.67891C20.9469 7.77257 21.5001 9 21.5001 10.9897C21.5001 14.4891 19.0436 17.6263 15.4695 19.1768L14.5768 17.7992C17.9121 15.9946 18.5639 13.6539 18.8245 12.178C18.2875 12.4557 17.5845 12.5533 16.8954 12.4895C15.091 12.3222 13.6689 10.8409 13.6689 9C13.6689 7.067 15.2359 5.5 17.1689 5.5C18.242 5.5 19.2681 5.99045 19.9167 6.67891ZM9.91669 6.67891C10.9469 7.77257 11.5001 9 11.5001 10.9897C11.5001 14.4891 9.04359 17.6263 5.46951 19.1768L4.57682 17.7992C7.91206 15.9946 8.56391 13.6539 8.82446 12.178C8.28746 12.4557 7.58452 12.5533 6.89539 12.4895C5.09102 12.3222 3.66895 10.8409 3.66895 9C3.66895 7.067 5.23595 5.5 7.16895 5.5C8.242 5.5 9.26814 5.99045 9.91669 6.67891Z",
    fill: "#A8A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleQuotes);
export default __webpack_public_path__ + "static/media/double-quotes.3f72ecac8670d508a1544800e10a9002.svg";
export { ForwardRef as ReactComponent };